import { forwardRef } from "react";
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/generated/IconApplicationStatusImport.tsx
const IconApplicationStatusImport = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 20 20",
	"aria-hidden": "true",
	"data-slot": "icon",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ jsx("path", {
		fill: "currentColor",
		d: "M13.333 1.667 17.5 5.833v11.674c0 .456-.37.826-.828.826H3.328a.833.833 0 0 1-.828-.826V2.493c0-.456.37-.826.828-.826zM10.833 10V6.667H9.167V10h-2.5L10 13.333 13.333 10z"
	})]
});
var IconApplicationStatusImport_default = forwardRef(IconApplicationStatusImport);
//#endregion
export { IconApplicationStatusImport_default as default };
